module.exports = __webpack_public_path__ + "static/media/NFT_placeholder.ccffff47.png";